module.exports = __webpack_public_path__ + "img/word4.8e2e08d2.webp";